import { JuloUpdateEntry } from "./types"

export const kalenderHelgdagarNoteringarEntry: JuloUpdateEntry = {
  slug: "2026-05-07-kalender-helgdagar-noteringar",
  date: "2026-05-07",
  title: "Helgdagar, noteringar och maxantal i kalendern",
  description:
    "Ni får nu tre nya saker i kalendern. Helgdagar (”röda dagar”) markeras med röd ram och helgdagens namn visas högst upp i dagrutan. På avvikande dagar kan ni nu lägga in en notering som syns både i [Inställningar → Bokningsbara platser](/settings/bookable-slots) och direkt i dagrutan i kalendern — tryck på pennan för att ändra noteringen utan att lämna kalendern, eller på plus-menyn för att lägga till en notering på en dag som inte redan har en avvikelse. Brevid jobbcyklen visas dessutom dagens kapacitet som ”antal / max”, så att ni alltid ser hur nära ni är taket för dagen.",
}
